export default function getReportPrintableType($type) {
    switch ($type) {
        case 'balance_sheet':
            return 'Balance Sheet';

        case 'profit_loss':
            return 'Profit Loss';

        case 'cashflow_statement':
            return 'Cashflow Statement';

        case 'trial_balance':
            return 'Trial Balance';

        case 'inventory/summary':
            return 'Inventory Summary';

        case 'inventory/detail':
            return 'Inventory Detail';

        case 'inventory/summary-by-location':
            return 'Inventory Summary By Location';

        case 'aged_receivables/summary':
            return 'Aged Receivables Summary';

        case 'aged_payables/summary':
            return 'Aged Payables Summary';

        case 'aged_receivables/detail':
            return 'Aged Receivables Detail';

        case 'aged_payables/detail':
            return 'Aged Payables Detail';

        case 'invoice_summary':
            return 'Invoice Summary';

        case 'bill_summary':
            return 'Bill Summary';

        case 'sales_credit_note_summary':
            return 'Sales Credit Note Summary';

        case 'purchase_credit_note_summary':
            return 'Purchase Credit Note Summary';

        case 'payment_summary':
            return 'Payment Summary';

        case 'purchase_payment_summary':
            return 'Purchase Payment Summary';

        case 'payment_voucher/summary':
            return 'Payment Voucher Summary';

        case 'official_receipt/summary':
            return 'Official Receipt Summary';

        case 'product_sales/summary':
            return 'Product Sales Summary';

        case 'product_sales/detail':
            return 'Product Sales Detail';

        case 'product_bundle_sales/summary':
            return 'Product Bundle Sales Summary';

        case 'product_purchases/summary':
            return 'Product Purchases Summary';

        case 'product_purchases/detail':
            return 'Product Purchases Detail';

        case 'tag_sales/summary':
            return 'Tag Sales Summary';

        case 'sales_by_customer/summary':
            return 'Sales by Customer Summary';

        case 'customer_quotes':
            return 'Customer Quotes';

        case 'delivery_orders_by_customer':
            return 'Delivery Orders by Customer';

        case 'purchases_by_supplier/summary':
            return 'Purchases by Supplier Summary';

        case 'supplier_orders':
            return 'Supplier Orders';

        case 'sales_orders_by_customer':
            return 'Sales Orders by Customer';

        case 'general_ledger':
            return 'General Ledger';

        case 'debtor_ledger':
            return 'Debtor Ledger';

        case 'creditor_ledger':
            return 'Creditor Ledger';

        case 'bank_reconciliation':
            return 'Bank Reconciliation';

        case 'reconciled_transactions':
            return 'Reconciled Transactions';

        case 'fixed_asset_list':
            return 'Fixed Asset List';

        case 'depreciation_schedule':
            return 'Depreciation Schedule';

        case 'sst_deemed_payments':
            return 'SST Deemed Payments';

        case 'sst_recovered_payments':
            return 'SST Recovered Payments';
        case 'sst_current_prepayments':
            return 'SST Current Prepayments';

        case 'sst_past_prepayments':
            return 'SST Past Prepayments';

        case 'disposal_schedule':
            return 'Disposal Schedule';

        case 'sst_payment_collection':
            return 'SST Payment Collection';

        case 'sst_02':
            return 'SST 02';

        case 'sst_by_product':
            return 'SST by Product';

        case 'sst_sales_detail':
            return 'SST Sales Detail';

        case 'sst_purchase_detail':
            return 'SST Purchase Detail';

        case 'financial_summary':
            return 'Financial Summary';

        case 'foreign_exchange_summary':
            return 'Foreign Exchange Summary';

        case 'unrealised_exchange_detail':
            return 'Unrealised Exchange Detail';

        case 'exchange_gain_loss':
            return 'Exchange Gain Loss';

        case 'transaction_list':
            return 'Transaction List';

        case 'payment_voucher_summary':
            return 'Payment Voucher Summary';

        case 'official_report_summary':
            return 'Official Report Summary';

        case 'item_sales_collection':
            return 'Item Sales Collection';

        case 'exchange_rates':
            return 'Exchange Rates';

        case 'journal_entry_detail':
            return 'Journal Entry Detail';

        case 'double_entry_detail':
            return 'Double Entry Detail';

        case 'profit_summary':
            return 'Profit Summary';

        case 'profit_detail':
            return 'Profit Detail';

        case 'chart_of_accounts':
            return 'Chart of Accounts';

        default:
            return 'Report';
    }
}
